<div class="position-relative -config-modal">
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="panel-title"> {{ configurationEdit ? 'Edit' : configurationView ? 'View' :
    'Add' }} {{isShown === 'site' ? ('plant' | translate) : isShown === 'tenant' ? ('client' | translate) :
    'Global'}} Configurations</div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="mt-top-2 field">
      <mat-form-field
        *ngIf="(!configurationEdit && !configurationView) && (!siteConfigurationsiteIdData && isShown == 'site')"
        class="field">
        <mat-label>Select {{'plant' | translate}}</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="siteId">
          <mat-option *ngFor="let item of siteList" [value]="item._id" (onSelectionChange)="getAttribList($event)">
            {{item.name | titlecase}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mt-top-2 field"
      *ngIf="(!configurationEdit && !configurationView) && (isShown === 'site' ||  isShown === 'tenant')">
      <mat-form-field class="field">
        <mat-label>Select Attribute</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="attributeList">
          <mat-option *ngFor="let attrib of attributeIdList; let i = index" [value]="attrib.id"
            (onSelectionChange)="getValues($event)">
            {{attrib.name}}
          </mat-option>
        </mat-select>
        <ng-container *ngIf="formSubmitted && formValues['attributeList'].errors">
          <mat-error *ngIf="formValues['attributeList'].errors?.['required']">
            <em class="fas fa-exclamation-circle mr-2"></em>Attribute is required
          </mat-error>
        </ng-container>
      </mat-form-field>
    </div>
    <div class="make-responsive">
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>Attribute</mat-label>
          <input matInput formControlName="attribute">
          <ng-container *ngIf="formSubmitted && formValues['attribute'].errors">
            <mat-error *ngIf="formValues['attribute'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Attribute is required
            </mat-error>
            <mat-error *ngIf="formValues['attribute'].errors?.['pattern']">
              <em class="fas fa-exclamation-circle mr-2"></em>Please enter a valid Attribute
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description">
          <ng-container *ngIf="formSubmitted && formValues['description'].errors">
            <mat-error *ngIf="formValues['description'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Description is required
            </mat-error>
            <mat-error *ngIf="formValues['description'].errors?.['pattern']">
              <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="isShown === 'global'">
        <mat-form-field class="field">
          <mat-label>Select Scope</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="type">
            <mat-option *ngFor="let item of type; let i = index" [value]="item.name" selected>
              {{item.name | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>Select Uom</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="uom">
            <mat-option *ngFor="let unit of uom; let i = index" [value]="unit.name" selected>
              {{unit.name | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Range Min</mat-label>
                    <input matInput type="number" min="0" name="rangemin" formControlName="rangemin">
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Range Max</mat-label>
                    <input matInput type="number" min="0" name="rangemax" formControlName="rangemax">
                </mat-form-field>
            </div> -->
    </div>
    <div class="mt-top-2 field d-flex" *ngIf="isShown == 'global' && !configurationView">
      <mat-label class="spacing-radio">Required</mat-label>
      <mat-checkbox class="example-margin" formControlName="mandatory" [(ngModel)]="selectedStatus">
      </mat-checkbox>
    </div>
    <div class="mt-top-2 field">
      <div class="d-flex w-100 align-items-center -text-area-field-height">
        <mat-form-field class="field">
          <mat-label>Value</mat-label>
          <textarea matInput cdkTextareaAutosize appjsonvalidator="" formControlName="values"
            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" (input)="validateJSON()"
            #values></textarea>
          <ng-container *ngIf="formSubmitted && formValues['values'].errors">
            <mat-error *ngIf="formValues['values'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Value is required
            </mat-error>
          </ng-container>
        </mat-form-field>
        <div *ngIf="form.value.values" [ngClass]="{'greenBtn' :isValidJson, 'redBtn':!isValidJson}">
          <em [className]="validateButtonStatus()"></em>
        </div>
        <div *ngIf="!configurationView">
          <button *ngIf="form.value.values" class="checkAvailability button p-3" type="button" (click)="formatJSON()"
            [ngClass]="{'greenBtn' :isValidJson, 'redBtn':!isValidJson}" title="Format Json"><img
              src="../../../assets/images/format.svg" class="w-30" alt="format">
          </button>
        </div>
      </div>
      <div *ngIf="!isValidJson" class="text-danger err-message"><em class="fas fa-exclamation-circle mr-2"></em>Please
        enter a valid Json Format!
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
          class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
    </div>
    <div class="btn-basket">
      <button mat-raised-button color="primary" data-dismiss="modal" type="button" (click)="closeModal()">Close</button>
      <button *ngIf="!configurationView" mat-raised-button color="primary" type="submit">
        {{ configurationEdit ? 'Update' : 'Submit' }}
      </button>
    </div>
  </form>
</div>